export default "__VITE_ASSET__sRoPdpfD__"